import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddUserAuth } from "../store/actions/userAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const axios = require("axios");

function Login({ setUserControlShow }) {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const getUserAuth = async function (e) {
    e.preventDefault();
    try {
      const { data } = await axios.post(process.env.REACT_APP_API_URL + "/login", {
        userName: username,
        passWord: password,
      });
      toast.info(`😀 Bienvenido ${data.firstName.toUpperCase()}!`, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      dispatch(AddUserAuth(data));
      setUserControlShow(false);
    } catch (error) {
      console.log("Error : ", error);
      toast.error(`Datos de Login incorrectos`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <form onSubmit={getUserAuth}>
      <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
        Nombre de Usuario
      </label>
      <input
        required
        type="text"
        name="username"
        className="form-control"
        placeholder="username"
        value={username}
        onInput={(e) => {
          setUsername(e.target.value);
        }}
      />
      <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
        Contraseña
      </label>
      <input
        required
        name="password"
        type="password"
        className="form-control"
        placeholder="password"
        id="inputPassword"
        value={password}
        onInput={(e) => {
          setPassword(e.target.value);
        }}
      />

      <Link className="nav-link text-dark text-end my-2" to="/password-reset">
        Recuperar Contraseña
      </Link>

      <button
        type="submit"
        id="signin-button"
        className="btn btn-dark rounded-pill d-block w-100 mt-2"
      >
        Entrar
      </button>
    </form>
  );
}

export default Login;
